import {
  FinanceCurrencyCodes,
  FinanceIntervalTypes,
} from '../../confirmFinances/confirmFinances.constants';

const standingOrdersFormDefinition = [
  {
    name: 'name',
    type: 'text',
    required: true,
  },
  {
    name: 'iban',
    type: 'iban',
    required: true,
    options: {
      validate: 'iban',
    },
  },
  {
    name: 'bankCode',
    type: 'text',
    options: {
      validate: 'bic',
    },
  },
  {
    name: 'amount',
    type: 'text',
    required: true,
  },
  {
    name: 'currency',
    type: 'select',
    typeOptions: {
      modelKey: 'key',
      selectables: FinanceCurrencyCodes,
      defaultValue: 'EUR',
    },
    required: true,
  },
  {
    name: 'interval',
    type: 'select',
    typeOptions: {
      modelKey: 'key',
      selectables: FinanceIntervalTypes,
    },
    required: true,
  },
  {
    name: 'executionDay',
    // TODO: change this to be a number. this is currently not possible, as the value is presented stringified and will cause a numfmt exception
    type: 'text',
    required: true,
  },
  {
    name: 'nextExecution',
    type: 'date',
    required: true,
  },
  {
    name: 'lastExecution',
    type: 'date',
  },
  {
    name: 'purpose',
    type: 'textarea',
    required: true,
  },
];

const appointmentTransfersFormDefinition = [
  {
    name: 'name',
    type: 'text',
    required: true,
  },
  {
    name: 'iban',
    type: 'iban',
    required: true,
    options: {
      validate: 'iban',
    },
  },
  {
    name: 'bankCode',
    type: 'text',
    options: {
      validate: 'bic',
    },
  },
  {
    name: 'amount',
    type: 'text',
    required: true,
  },
  {
    name: 'currency',
    type: 'select',
    typeOptions: {
      modelKey: 'key',
      selectables: FinanceCurrencyCodes,
      defaultValue: 'EUR',
    },
    required: true,
  },
  {
    name: 'nextExecution',
    label: 'executionDate',
    type: 'date',
    required: true,
  },
  {
    name: 'purpose',
    type: 'textarea',
    required: true,
  },
];

export const StandingOrderFormFields = (type) => {
  return type === 'scheduled'
    ? appointmentTransfersFormDefinition
    : standingOrdersFormDefinition;
};
